import { PageUrl } from '../../../../pages/utils/page-url';
import type { LinksToRetrieve } from '../types';

export const links: LinksToRetrieve[] = [
    {
        id: 1,
        url: { action: PageUrl.CUSTOMER_CONTACT_US },
    },
    // TODO: Remove this link once the PWA Account redirect is in production
    // https://dbuy-fi.atlassian.net/browse/SLTBE-5781
    {
        id: 2,
        url: { action: PageUrl.LOGIN_SHOW },
    },
    {
        id: 3,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'shipping'] },
    },
    {
        id: 4,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'returnandexchanges'] },
    },
    {
        id: 5,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'guarantee'] },
    },
    {
        id: 6,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'extendfaq'] },
    },
    {
        id: 7,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'accessibility'] },
    },
    {
        id: 8,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'faqs'] },
    },
    {
        id: 9,
        url: { action: PageUrl.PAGE_SHOW, args: ['cid', 'cooking-class-faq'] },
    },
    {
        id: 11,
        url: {
            action: PageUrl.PAGE_SHOW,
            args: ['cid', 'terms_and_conditions'],
        },
    },
];
